import { useContext } from "react"
import { EntregadoresContext } from "./EntregadoresContext"

export function useEntregadoresContext() {
    return useContext(EntregadoresContext)
}
